import { ZButton } from "@/shared/components/button";
import { ZModal, ZModalBody, ZModalContent, ZModalFooter, ZModalHeader } from "@/shared/components/modal";
import type { FC } from "react";

interface ConfirmPublishModalProps {
  /**
   * Handler called when the user confirms to proceed
   */
  onConfirm: () => void;

  /**
   * Handler called when the modal is closed without confirming
   */
  onClose: () => void;

  /**
   * Whether the modal is open or not
   */
  isOpen: boolean;

  /**
   * The title of the confirmation modal
   * @default "Confirm Completion?"
   */
  title?: string;

  /**
   * The primary message to display
   * @default "You still have unanswered questions. Once submitted, your responses are final and cannot be changed. Are you sure you want to proceed?"
   */
  message?: string;

  /**
   * Whether the confirm action is loading
   * @default false
   */
  isLoading?: boolean;
}

const ConfirmPublishModal: FC<ConfirmPublishModalProps> = ({
  onConfirm,
  onClose,
  isOpen,
  title = "Confirm Completion?",
  message = "You still have unanswered questions. Once submitted, your responses are final and cannot be changed. Are you sure you want to proceed?",
  isLoading = false,
}) => {
  return (
    <ZModal
      isOpen={isOpen}
      onOpenChange={onClose}
    >
      <ZModalContent className="max-w-xl">
        <ZModalHeader className="flex text-lg flex-col w-full items-center pb-0">
          <p className="text-[20px] font-semibold">{title}</p>
        </ZModalHeader>
        <ZModalBody className="pt-4 pb-2">
          <div className="flex flex-col items-center">
            <p className="text-[14px] text-[#777780] text-center mb-6">
              {message}
            </p>
          </div>
        </ZModalBody>
        <ZModalFooter className="justify-center gap-4 pt-2 pb-6">
          <ZButton
            variant="bordered"
            className="px-3 py-1 text-medium flex-1"
            onClick={onClose}
            disabled={isLoading}
          >
            Back
          </ZButton>
          <ZButton
            className="px-3 py-1 text-medium flex-1 bg-primary text-white"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Yes, Confirm
          </ZButton>
        </ZModalFooter>
      </ZModalContent>
    </ZModal>
  );
};

export default ConfirmPublishModal;
